import { useEffect } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import EbayReturnsTable from "../../components/ebayReturns/EbayReturnsTable";


export default function EbayReturns() {
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: "eBay Returns",
      desc: "View and manage returns on orders from eBay",
    });
  }, []);

  return (
      <EbayReturnsTable />
  );
}
